module.exports = __webpack_public_path__ + "img/alarm-clock.0ed760a3.svg";